import { useEffect, useState } from "react";
import "./ModalAddNewTraining.scss";
import { Select, DatePicker, Input, Steps, TimePicker, Button, Divider } from "antd";
import { Controller } from "react-hook-form";
import useTrainingCardList from "../../logic/useTrainingCardList";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import "../SessionCard/SessionCard.scss";

function ModalAddNewTraining({
  isModalOpen,
  setIsModalOpen,
  isUpcomingTraining,
}) {

  const customDateFormat = 'YYYY-MM-DD';

  const { RangePicker } = DatePicker;
  const [currentStep, setCurrentStep] = useState(0);
  const [selectedDates, setSelectedDates] = useState([]);
  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === 1;
  const [data, setData] = useState({});

  const handleCancel = () => {
    reset();
    setIsModalOpen(!isModalOpen);
    setCurrentStep(0);
    setSessionsToApply([
      {
        from: null,
        to: null,
      },
    ]);
  };
  const {
    selectedUsers,
    courseOptions,
    handleSubmit,
    errors,
    reset,
    control,
    selectedOptionLanguage,
    onSubmitTraining,
    watch,
    setValue,
    handleAddSessionToApply,
    handleDeleteSessionToApply,
    sessionsToApply,
    setSessionsToApply,
  } = useTrainingCardList(
    isUpcomingTraining,
    data,
    handleCancel,
    setCurrentStep
  );

  const stepsItems = [
    {
      title: "Step1",
      className: "steps1",
    },
    {
      title: "Step2",
      className: "steps2",
    },
  ];

  const setDataForSelectedDates = (dates) => {
    const newData = {};
    dates.forEach((date) => {
      //const dateString = date;
      newData[date] = newData[date] || [];

      if (data[date]) {
        newData[date] = data[date];
      } else {
        newData[date].push({
          date,
          from: null,
          to: null,
        });
      }
    });
    setData(newData);
  };

  const handleAddSession = (date) => {
    const newData = { ...data };
    // const formattedDate = date;

    if (newData[date]) {
      newData[date].push({
        date,
        from: null,
        to: null,
      });
      setData(newData);
    } else {
      newData[date] = [
        { date, from: null, to: null },
      ];
      setData(newData);
    }
  };

  useEffect(() => {
    const dates = watch("rangeDate");
    if (dates) {
      setSelectedDates(
        getDatesBetweenDates(watch("rangeDate")[0], watch("rangeDate")[1])
      );
    }
    return () => {
      setSelectedDates([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch("rangeDate")]);

  const nextStep = () => {
    const dates = getDatesBetweenDates(
      watch("rangeDate")[0],
      watch("rangeDate")[1]
    );
    setDataForSelectedDates(dates);
    if (!isLastStep) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleDeleteSession = (date) => {
    const newData = { ...data };
    const sessions = newData[date];

    if (sessions && sessions.length > 1) {
      sessions.pop();
      setValue(`time_${date}_${sessions.length}`, null);
      setData(newData);
    }
  };

  const prevStep = () => {
    if (!isFirstStep) {
      setCurrentStep(currentStep - 1);
    }
  };
  const getDatesBetweenDates = (startDate, endDate) => {
    const dates = [];
    startDate = dayjs(startDate).unix();
    endDate = dayjs(endDate).unix();
    while(startDate <= endDate){
      dates.push(dayjs.unix(startDate).format(customDateFormat));
      startDate += 60*60*24;
    }
    return dates;
  };

  if (!isModalOpen) {
    return null;
  }
  const disabledDate = (current) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return current && current.valueOf() < today.valueOf();
  };
  const SessionForm = ({ index, control, errors, date, session }) => {
    const handleSessionChange = (from, to) => {
      const newData = { ...data };
      const sessions = newData[date];
      const currentSession = sessions[index];
      currentSession.from = from;
      currentSession.to = to;
      setData(newData);
    };
    return (
      <div className="session-card-content-add-training">
        <label>Session {index + 1}</label>
        <div className="session-card-time">
          <div className="session-card-start">
            <label>Time : </label>
            <Controller
              name={`time_${date}_${index}`}
              control={control}
              rules={{ required: "Enter Time..." }}
              render={({ field }) => (
                <TimePicker.RangePicker
                  format="h:mm a"
                  {...field}
                  onChange={(timeValue) => {
                    field.onChange(timeValue);
                    const format = "h:mm a";
                    handleSessionChange(
                      timeValue?.[0]?.format(format),
                      timeValue?.[1]?.format(format)
                    );
                  }}
                />
              )}
            />

            {errors[`time_${date}_${index}`] && (
              <span className="error-msg" style={{ color: "red" }}>
                {errors[`time_${date}_${index}`]?.message}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  };

  const SessionToApply = ({ index, session }) => {
    const updateSessionToApply = (from, to) => {
      const updatedSessionsToApply = [...sessionsToApply];
      updatedSessionsToApply[index].from = from;
      updatedSessionsToApply[index].to = to;
      setSessionsToApply(updatedSessionsToApply);
    };

    return (
      <div className="session-card-content-add-training">
        <label>Session {index + 1}</label>
        <div className="session-card-time">
          <div className="session-card-start">
            <label>Time : </label>
            <TimePicker.RangePicker
              format="h:mm a"
              value={[
                session?.from ? dayjs(session?.from, "h:mm a") : null,
                session?.to ? dayjs(session?.to, "h:mm a") : null,
              ]}
              onChange={(timeValue) => {
                const format = "h:mm a";
                const from = timeValue?.[0]?.format(format) || null;
                const to = timeValue?.[1]?.format(format) || null;
                updateSessionToApply(from, to);
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  const addListSessions = () => {
    const updatedData = { ...data };

    selectedDates.forEach((date) => {
      sessionsToApply.forEach((session, index) => {

        const fromTime = session.from
          ? dayjs(`${date} ${session.from}`, `${customDateFormat} h:mm a`)
          : null;
        const toTime = session.to
          ? dayjs(`${date} ${session.to}`, `${customDateFormat} h:mm a`)
          : null;

        let indexEmpty = 0;
        while (
          updatedData[date][indexEmpty] &&
          updatedData[date][indexEmpty].from &&
          updatedData[date][indexEmpty].to &&
          indexEmpty < updatedData[date].length
        ) {
          indexEmpty++;
        }

        if (
          updatedData[date][indexEmpty] &&
          !updatedData[date][indexEmpty].from &&
          !updatedData[date][indexEmpty].to
        ) {
          setValue(`time_${date}_${indexEmpty}`, [
            fromTime,
            toTime,
          ]);
          updatedData[date][indexEmpty].from =
            session.from;
          updatedData[date][indexEmpty].to = session.to;
        } else {
          const lengthList = updatedData[date].length;
          setValue(`time_${date}_${lengthList}`, [
            fromTime,
            toTime,
          ]);

          updatedData[date].push({
            date,
            from: session.from,
            to: session.to,
          });
        }
      });
    });
    setData(updatedData);
    setSessionsToApply([
      {
        from: null,
        to: null,
      },
    ]);
  };

  return (
    <div
      className={`modal-overlay-add-training ${
        isModalOpen ? "modal-overlay-add-training show" : "modal-overlay-add-training"
      }`}
    >
      <div className="modal-content">
        <div className="modal-header">
          <h3>Add New Training</h3>
        </div>
        <form>
          <Steps current={currentStep} items={stepsItems} />
          {currentStep === 0 && (
            <div className="modal-body">
              <div className="modal-cards">
                <div className="input-group">
                  <div className="input-group-item">
                    <Controller
                      name="course"
                      control={control}
                      rules={{ required: "Select a course is required" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={courseOptions}
                          allowClear
                          placeholder="Select a course"
                        />
                      )}
                    />
                    {errors.course && (
                      <span className="error-msg">
                        {errors.course?.message}
                      </span>
                    )}
                  </div>
                  <div className="input-group-item">
                    <Controller
                      name="trainer"
                      control={control}
                      rules={{ required: "Select a trainer is required" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={selectedUsers}
                          allowClear
                          placeholder="Select a trainer"
                        />
                      )}
                    />
                    {errors.trainer && (
                      <span className="error-msg">
                        {errors.trainer?.message}
                      </span>
                    )}
                  </div>
                </div>

                <div className="input-group">
                  <div className="input-group-item">
                    <Controller
                      name="rangeDate"
                      control={control}
                      rules={{ required: "Select a range date is required" }}
                      render={({ field }) => (
                        <RangePicker
                          format={customDateFormat}
                          {...field}
                          disabledDate={disabledDate}
                        />
                      )}
                    />
                    {errors.rangeDate && (
                      <span className="error-msg">
                        {errors.rangeDate?.message}
                      </span>
                    )}
                  </div>
                  <div className="input-group-item">
                    <Controller
                      name="location"
                      control={control}
                      rules={{ required: "Select a location is required" }}
                      render={({ field }) => (
                        <Input {...field} placeholder="Select a location" />
                      )}
                    />
                    {errors.location && (
                      <span className="error-msg">
                        {errors.location?.message}
                      </span>
                    )}
                  </div>
                </div>

                <div className="input-group">
                  <div className="input-group-item">
                    <Controller
                      name="equipment"
                      control={control}
                      render={({ field }) => (
                        <Input {...field} placeholder="Enter Equipment" />
                      )}
                    />
                  </div>

                  <div className="input-group-item">
                    <Controller
                      name="language"
                      control={control}
                      rules={{ required: "Select a language is required" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={selectedOptionLanguage}
                          allowClear
                          placeholder="Select a language"
                        />
                      )}
                    />
                    {errors.language && (
                      <span className="error-msg">
                        {errors.language?.message}
                      </span>
                    )}
                  </div>
                </div>

                <div className="input-group">
                  <div className="input-group-item">
                    <label>Guaranteed</label>
                    <Controller
                      name="isGuaranteed"
                      control={control}
                      defaultValue={false}
                      render={({ field }) => (
                        <input
                          type="checkbox"
                          checked={field.value}
                          onChange={(e) => field.onChange(e.target.checked)}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          {currentStep === 0 && (
            <div className="modal-footer">
              <button
                onClick={() => prevStep()}
                className={isFirstStep ? "btn-disabled" : "btn-prev"}
              >
                Previous
              </button>
              {
                <button onClick={handleSubmit(nextStep)} className="btn-next">
                  Next
                </button>
              }
              <button className="btn-cancel" onClick={() => handleCancel()}>
                Cancel
              </button>
            </div>
          )}
        </form>

        <form onSubmit={handleSubmit(onSubmitTraining)}>
          {currentStep === 1 && (
            <div className="modal-step2">
              <div className="modal-step2-date">
                <label>Start : {dayjs(selectedDates[0], customDateFormat).format('DD-MM-YYYY')}</label>
                <label>
                  End :{" "}
                  {dayjs(selectedDates[selectedDates.length - 1], customDateFormat).format('DD-MM-YYYY')}
                </label>
              </div>
              <Divider orientation="left" style={{ color: "#185993", fontSize: "17px", fontWeight: "bolder" }}>Apply for all</Divider>
              <div className="session-card-container">
                <div className="session-card-header">
                  <label></label>
                  <div className="session-card-icons">
                    <DeleteOutlined
                      className="trashIcon"
                      onClick={() => handleDeleteSessionToApply()}
                    />
                    <span onClick={() => handleAddSessionToApply()}>
                      <PlusOutlined className="addIcon" />
                    </span>
                  </div>
                </div>
                {sessionsToApply.map((session, index) => (
                  <SessionToApply key={index} index={index} session={session} />
                ))}
                <div className="apply-btn">
                  <Button type="primary" onClick={() => addListSessions()}>
                    Apply
                  </Button>
                </div>
              </div>
              <Divider />
              {selectedDates.map((date, index) => (
                <div className="session-card-container" key={index}>
                  <div className="session-card-header">
                    <label>Date: {dayjs(date, customDateFormat).format('DD-MM-YYYY')}</label>
                    <div className="session-card-icons">
                      <DeleteOutlined
                        className="trashIcon"
                        onClick={() => handleDeleteSession(date)}
                      />
                      <span onClick={() => handleAddSession(date)}>
                        <PlusOutlined className="addIcon" />
                      </span>
                    </div>
                  </div>
                  {data[date]?.map(
                    (session, sessionIndex) => (
                      <SessionForm
                        key={sessionIndex}
                        index={sessionIndex}
                        date={date}
                        session={session}
                        control={control}
                        errors={errors}
                      />
                    )
                  )}
                </div>
              ))}
            </div>
          )}

          {currentStep === 1 && (
            <div className="modal-footer">
              <button
                onClick={() => prevStep()}
                className={isFirstStep ? "btn-disabled" : "btn-prev"}
              >
                Previous
              </button>
              {!isFirstStep && (
                <button type="submit" className="btn-next">
                  Add
                </button>
              )}
              <button className="btn-cancel" onClick={() => handleCancel()}>
                Cancel
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

export default ModalAddNewTraining;
